<template>
	<div id="BeginForm" class="fullSize">

		<div id="BeginForm_wrapper" class="fullSize">

			<div id="BeginForm_innerwrapper"> 
				<h1 class="title_bold beginformtitle">{{ App.lang.get('Welcome') }}</h1>

				<form action="#" method="POST"
				v-on:submit="submitForm">

					<div class="form_par title_bold"><label for="BeginForm_country">{{ App.lang.get('Please verify your country') }}<span class="mandatory">*</span></label></div>

					<div class="form_input combo">
						<select id="BeginForm_country" name="BeginForm_country" required>
							<optgroup label="Europe">
								<option value="AT">Austria</option>
								<option value="BE">Belgium</option>
								<option value="DE">Germany</option>
								<option value="FI">Finland</option>
								<option value="FR">France</option>
								<option value="IE">Ireland</option>
								<option value="IT">Italy</option>
								<option value="NL">Netherlands</option>
								<option value="NO">Norway</option>
								<option value="PL">Poland</option>
								<option value="PT">Portugal</option>
								<option value="ES">Spain</option>
								<option value="SE">Sweden</option>
								<option value="CH">Switzerland</option>
								<option value="GB">United Kingdom</option>
							</optgroup>
							<!-- All other countries -->
							<option value="AF">Afghanistan</option>
							<option value="AL">Albania</option>
							<option value="DZ">Algeria</option>
							<option value="AS">American Samoa</option>
							<option value="AD">Andorra</option>
							<option value="AO">Angola</option>
							<option value="AI">Anguilla</option>
							<option value="AQ">Antarctica</option>
							<option value="AG">Antigua and Barbuda</option>
							<option value="AR">Argentina</option>
							<option value="AM">Armenia</option>
							<option value="AW">Aruba</option>
							<option value="AU">Australia</option>
							<!--<option value="AT">Austria</option>-->
							<option value="AZ">Azerbaijan</option>
							<option value="BS">Bahamas (the)</option>
							<option value="BH">Bahrain</option>
							<option value="BD">Bangladesh</option>
							<option value="BB">Barbados</option>
							<option value="BY">Belarus</option>
							<!--<option value="BE">Belgium</option>-->
							<option value="BZ">Belize</option>
							<option value="BJ">Benin</option>
							<option value="BM">Bermuda</option>
							<option value="BT">Bhutan</option>
							<option value="BO">Bolivia (Plurinational State of)</option>
							<option value="BQ">Bonaire, Sint Eustatius and Saba</option>
							<option value="BA">Bosnia and Herzegovina</option>
							<option value="BW">Botswana</option>
							<option value="BV">Bouvet Island</option>
							<option value="BR">Brazil</option>
							<option value="IO">British Indian Ocean Territory (the)</option>
							<option value="BN">Brunei Darussalam</option>
							<option value="BG">Bulgaria</option>
							<option value="BF">Burkina Faso</option>
							<option value="BI">Burundi</option>
							<option value="CV">Cabo Verde</option>
							<option value="KH">Cambodia</option>
							<option value="CM">Cameroon</option>
							<option value="CA">Canada</option>
							<option value="KY">Cayman Islands (the)</option>
							<option value="CF">Central African Republic (the)</option>
							<option value="TD">Chad</option>
							<option value="CL">Chile</option>
							<option value="CN">China</option>
							<option value="CX">Christmas Island</option>
							<option value="CC">Cocos (Keeling) Islands (the)</option>
							<option value="CO">Colombia</option>
							<option value="KM">Comoros (the)</option>
							<option value="CD">Congo (the Democratic Republic of the)</option>
							<option value="CG">Congo (the)</option>
							<option value="CK">Cook Islands (the)</option>
							<option value="CR">Costa Rica</option>
							<option value="HR">Croatia</option>
							<option value="CU">Cuba</option>
							<option value="CW">Curaçao</option>
							<option value="CY">Cyprus</option>
							<option value="CZ">Czechia</option>
							<option value="CI">Côte d'Ivoire</option>
							<option value="DK">Denmark</option>
							<option value="DJ">Djibouti</option>
							<option value="DM">Dominica</option>
							<option value="DO">Dominican Republic (the)</option>
							<option value="EC">Ecuador</option>
							<option value="EG">Egypt</option>
							<option value="SV">El Salvador</option>
							<option value="GQ">Equatorial Guinea</option>
							<option value="ER">Eritrea</option>
							<option value="EE">Estonia</option>
							<option value="SZ">Eswatini</option>
							<option value="ET">Ethiopia</option>
							<option value="FK">Falkland Islands (the) [Malvinas]</option>
							<option value="FO">Faroe Islands (the)</option>
							<option value="FJ">Fiji</option>
							<!--<option value="FI">Finland</option>-->
							<!--<option value="FR">France</option>-->
							<option value="GF">French Guiana</option>
							<option value="PF">French Polynesia</option>
							<option value="TF">French Southern Territories (the)</option>
							<option value="GA">Gabon</option>
							<option value="GM">Gambia (the)</option>
							<option value="GE">Georgia</option>
							<!--<option value="DE">Germany</option>-->
							<option value="GH">Ghana</option>
							<option value="GI">Gibraltar</option>
							<option value="GR">Greece</option>
							<option value="GL">Greenland</option>
							<option value="GD">Grenada</option>
							<option value="GP">Guadeloupe</option>
							<option value="GU">Guam</option>
							<option value="GT">Guatemala</option>
							<option value="GG">Guernsey</option>
							<option value="GN">Guinea</option>
							<option value="GW">Guinea-Bissau</option>
							<option value="GY">Guyana</option>
							<option value="HT">Haiti</option>
							<option value="HM">Heard Island and McDonald Islands</option>
							<option value="VA">Holy See (the)</option>
							<option value="HN">Honduras</option>
							<option value="HK">Hong Kong</option>
							<option value="HU">Hungary</option>
							<option value="IS">Iceland</option>
							<option value="IN">India</option>
							<option value="ID">Indonesia</option>
							<option value="IR">Iran (Islamic Republic of)</option>
							<option value="IQ">Iraq</option>
							<!--<option value="IE">Ireland</option>-->
							<option value="IM">Isle of Man</option>
							<option value="IL">Israel</option>
							<!--<option value="IT">Italy</option>-->
							<option value="JM">Jamaica</option>
							<option value="JP">Japan</option>
							<option value="JE">Jersey</option>
							<option value="JO">Jordan</option>
							<option value="KZ">Kazakhstan</option>
							<option value="KE">Kenya</option>
							<option value="KI">Kiribati</option>
							<option value="KP">Korea (the Democratic People's Republic of)</option>
							<option value="KR">Korea (the Republic of)</option>
							<option value="KW">Kuwait</option>
							<option value="KG">Kyrgyzstan</option>
							<option value="LA">Lao People's Democratic Republic (the)</option>
							<option value="LV">Latvia</option>
							<option value="LB">Lebanon</option>
							<option value="LS">Lesotho</option>
							<option value="LR">Liberia</option>
							<option value="LY">Libya</option>
							<option value="LI">Liechtenstein</option>
							<option value="LT">Lithuania</option>
							<option value="LU">Luxembourg</option>
							<option value="MO">Macao</option>
							<option value="MG">Madagascar</option>
							<option value="MW">Malawi</option>
							<option value="MY">Malaysia</option>
							<option value="MV">Maldives</option>
							<option value="ML">Mali</option>
							<option value="MT">Malta</option>
							<option value="MH">Marshall Islands (the)</option>
							<option value="MQ">Martinique</option>
							<option value="MR">Mauritania</option>
							<option value="MU">Mauritius</option>
							<option value="YT">Mayotte</option>
							<option value="MX">Mexico</option>
							<option value="FM">Micronesia (Federated States of)</option>
							<option value="MD">Moldova (the Republic of)</option>
							<option value="MC">Monaco</option>
							<option value="MN">Mongolia</option>
							<option value="ME">Montenegro</option>
							<option value="MS">Montserrat</option>
							<option value="MA">Morocco</option>
							<option value="MZ">Mozambique</option>
							<option value="MM">Myanmar</option>
							<option value="NA">Namibia</option>
							<option value="NR">Nauru</option>
							<option value="NP">Nepal</option>
							<!--<option value="NL">Netherlands (the)</option>-->
							<option value="NC">New Caledonia</option>
							<option value="NZ">New Zealand</option>
							<option value="NI">Nicaragua</option>
							<option value="NE">Niger (the)</option>
							<option value="NG">Nigeria</option>
							<option value="NU">Niue</option>
							<option value="NF">Norfolk Island</option>
							<option value="MP">Northern Mariana Islands (the)</option>
							<!--<option value="NO">Norway</option>-->
							<option value="OM">Oman</option>
							<option value="PK">Pakistan</option>
							<option value="PW">Palau</option>
							<option value="PS">Palestine, State of</option>
							<option value="PA">Panama</option>
							<option value="PG">Papua New Guinea</option>
							<option value="PY">Paraguay</option>
							<option value="PE">Peru</option>
							<option value="PH">Philippines (the)</option>
							<option value="PN">Pitcairn</option>
							<!--<option value="PL">Poland</option>-->
							<!--<option value="PT">Portugal</option>-->
							<option value="PR">Puerto Rico</option>
							<option value="QA">Qatar</option>
							<option value="MK">Republic of North Macedonia</option>
							<option value="RO">Romania</option>
							<option value="RU">Russian Federation (the)</option>
							<option value="RW">Rwanda</option>
							<option value="RE">Réunion</option>
							<option value="BL">Saint Barthélemy</option>
							<option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
							<option value="KN">Saint Kitts and Nevis</option>
							<option value="LC">Saint Lucia</option>
							<option value="MF">Saint Martin (French part)</option>
							<option value="PM">Saint Pierre and Miquelon</option>
							<option value="VC">Saint Vincent and the Grenadines</option>
							<option value="WS">Samoa</option>
							<option value="SM">San Marino</option>
							<option value="ST">Sao Tome and Principe</option>
							<option value="SA">Saudi Arabia</option>
							<option value="SN">Senegal</option>
							<option value="RS">Serbia</option>
							<option value="SC">Seychelles</option>
							<option value="SL">Sierra Leone</option>
							<option value="SG">Singapore</option>
							<option value="SX">Sint Maarten (Dutch part)</option>
							<option value="SK">Slovakia</option>
							<option value="SI">Slovenia</option>
							<option value="SB">Solomon Islands</option>
							<option value="SO">Somalia</option>
							<option value="ZA">South Africa</option>
							<option value="GS">South Georgia and the South Sandwich Islands</option>
							<option value="SS">South Sudan</option>
							<!--<option value="ES">Spain</option>-->
							<option value="LK">Sri Lanka</option>
							<option value="SD">Sudan (the)</option>
							<option value="SR">Suriname</option>
							<option value="SJ">Svalbard and Jan Mayen</option>
							<!--<option value="SE">Sweden</option>-->
							<!--<option value="CH">Switzerland</option>-->
							<option value="SY">Syrian Arab Republic</option>
							<option value="TW">Taiwan (Province of China)</option>
							<option value="TJ">Tajikistan</option>
							<option value="TZ">Tanzania, United Republic of</option>
							<option value="TH">Thailand</option>
							<option value="TL">Timor-Leste</option>
							<option value="TG">Togo</option>
							<option value="TK">Tokelau</option>
							<option value="TO">Tonga</option>
							<option value="TT">Trinidad and Tobago</option>
							<option value="TN">Tunisia</option>
							<option value="TR">Turkey</option>
							<option value="TM">Turkmenistan</option>
							<option value="TC">Turks and Caicos Islands (the)</option>
							<option value="TV">Tuvalu</option>
							<option value="UG">Uganda</option>
							<option value="UA">Ukraine</option>
							<option value="AE">United Arab Emirates (the)</option>
							<!--<option value="GB">United Kingdom of Great Britain and Northern Ireland (the)</option>-->
							<option value="UM">United States Minor Outlying Islands (the)</option>
							<option value="US">United States of America (the)</option>
							<option value="UY">Uruguay</option>
							<option value="UZ">Uzbekistan</option>
							<option value="VU">Vanuatu</option>
							<option value="VE">Venezuela (Bolivarian Republic of)</option>
							<option value="VN">Viet Nam</option>
							<option value="VG">Virgin Islands (British)</option>
							<option value="VI">Virgin Islands (U.S.)</option>
							<option value="WF">Wallis and Futuna</option>
							<option value="EH">Western Sahara</option>
							<option value="YE">Yemen</option>
							<option value="ZM">Zambia</option>
							<option value="ZW">Zimbabwe</option>
							<option value="AX">Åland Islands</option>
						</select>
					</div>

					<div style="height: 10px;"></div>

					<div class="form_label_small">
						<label for="BeginForm_firstname">
							{{ App.lang.get('First name') }}
						</label></div>
					<div class="form_input text">
						<input type="text" id="BeginForm_firstname" name="BeginForm_firstname" ref="BeginForm_firstname"
						v-model="App.visitor.firstName" />
					</div>

					<div class="form_label_small">
						<label for="BeginForm_lastname">
							{{ App.lang.get('Last name') }}
							</label>
						</div>
					<div class="form_input text">
						<input type="text" id="BeginForm_lastname" name="BeginForm_lastname" ref="BeginForm_lastname"
						v-model="App.visitor.lastName"  />
					</div>

					<div class="form_label_small">
						<label for="BeginForm_email">
							{{ App.lang.get('Email') }}
						</label>
					</div>
					<div class="form_input email">
						<input type="email" id="BeginForm_email" name="BeginForm_email" ref="BeginForm_email"
						v-model="App.visitor.email"  />
					</div>

					<div style="height: 10px;"></div>

					<div class="form_input_checkbox">

						<p>By selecting <i><b>"Yes, I am an HCP"</b></i>, you hereby confirm you are a Healthcare Provider and consent to view the contents of this site.</p>
					
						<input type="checkbox" id="BeginForm_hcp" name="BeginForm_hcp" required 
						v-model="App.visitor.hcp"/>
						<label for="BeginForm_hcp"> <b><small> Yes, I am an HCP </small></b><span class="mandatory">*</span></label>

						<p><i>This information is intended solely for the use of healthcare professionals.
						A healthcare professional must always rely on his or her own professional clinical judgement when deciding whether to use a particular product when treating a particular patient. Stryker does not dispense medical advice and recommends that healthcare professionals be trained in the use of any particular product before using it in a procedure or surgery. Products may not be available in all markets because product availability is subject to regulatory and/or medical practices in individual markets.</i></p>
					</div>

					<div style="height: 10px;"></div>

					<div class="form_input_checkbox">
					
						<input type="checkbox" id="BeginForm_privacy" name="BeginForm_privacy" required 
						v-model="App.visitor.acknowledgePrivacy" />
						<label for="BeginForm_privacy"> 
							<b><small> I acknowledge Stryker’s <a href="" v-on:click="privacy">Privacy Statement</a> and <a href="" v-on:click="cookies">Cookie disclaimer</a> </small><span class="mandatory">*</span></b>
						</label>

					</div>

					<div style="height: 10px;"></div>

					<div class="form_input_checkbox">
					
						<input type="checkbox" id="BeginForm_newsletter" name="BeginForm_newsletter"
						v-model="App.visitor.acceptsNewsletter" />
						<label for="BeginForm_newsletter"> 
							<b><small> I would like to receive from Stryker news and updates on product and service offerings </small></b>
						</label>

					</div>

					<div style="height: 10px;"></div>

					<div class="wrapwidth">
						<p><span class="mandatory">*<i><small>Required</small></i></span></p>
						<p style=" font-style:italic;">
							By clicking <b>"Continue"</b> I confirm that I understand that the content of the virtual exhibit is in English. If you want access to in language 		resources please visit <a href="http://www.stryker.com" target="_blank">www.stryker.com</a>
						</p>
						
						<p style="text-align: right;">
							<input  class="title_bold" type="submit" id="BeginForm_submit" name="BeginForm_submit" value="Continue" />
						</p>
					</div>

					
					

				</form>
			</div>

			

		</div>

	</div>
</template>

<script>
export default {
	name: 'BeginForm',
	props: {
		App: Object
	},
	data : function() {
		return {
			navLang: 'EN',
		}
	},
	mounted() {
		
		var langParams = navigator.language.split('-')
		if(langParams.length > 1)
			this.navLang = langParams[1]
		else if(langParams.length < 2)
			this.navLang = langParams[0].toUpperCase()
		this.autoSelectCountry()
	},
	created() {
	},
	methods : {

		autoSelectCountry() {
			document.getElementById('BeginForm_country').value = this.navLang
		},

		privacy(e) {
			this.App.privacyPageDisplay = true;
			e.preventDefault();
			return false;
		},

		cookies(e) {
			this.App.cookiesPageDisplay = true;
			e.preventDefault();
			return false;
		},

		submitForm(e) {
			
			if(this.App.visitor.acknowledgePrivacy && this.App.visitor.hcp) {

				document.dispatchEvent(new CustomEvent( 'beginFormComplete', { 'detail' : {
					visitor: this.App.visitor
				}}))

				this.App.beginFormCompleted = true


			}

			e.preventDefault();
			return false;
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
